import { IToursSectionState } from "./types";
import { TourOrderByEnum, OrderByDirectionEnum } from "../../../store";

export const initialState: IToursSectionState = {
    toursTotal: 0,
    orderBy: TourOrderByEnum.date,
    orderByDirection: OrderByDirectionEnum.desc,
    showCategories: false,
    showMap: false,
    showSortMenu: false
}